import { ENV } from "../../config/runtimeEnv";
import {
	VitalSignField,
	VitalSignPayload,
	VitalSignRecord,
} from "../../types/healthcare/VitalSignTypes";
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";

const BASE = ENV.VITE_HEALTHCARE_SERVER;

export const listVitalSigns = async (
	patientId: UserUuid,
): Promise<VitalSignRecord[]> => {
	const res = await http.get(`${BASE}/patients/${patientId}/vital-signs`);
	return res.data.data;
};

export const createVitalSign = async (
	patientId: UserUuid,
	payload: VitalSignPayload,
): Promise<VitalSignRecord> => {
	const res = await http.post(`${BASE}/patients/${patientId}/vital-signs`, payload);
	return res.data.data;
};

export const updateVitalSign = async (
	patientId: UserUuid,
	id: number,
	payload: VitalSignPayload,
): Promise<VitalSignRecord> => {
	const res = await http.put(`${BASE}/patients/${patientId}/vital-signs/${id}`, payload);
	return res.data.data;
};

export const deleteVitalSign = async (
	patientId: UserUuid,
	id: number,
): Promise<{ message: string }> => {
	const res = await http.delete(`${BASE}/patients/${patientId}/vital-signs/${id}`);
	return res.data;
};

export const getVitalSignsSchema = async (): Promise<VitalSignField[]> => {
	const res = await http.get(`${BASE}/vital-signs/schema`);
	return res.data.data;
};
